import { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { primaryShades } from '../../theme/theme';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const QRCodeWithHover = ({ catalogue, getQrCodeUrl, onDownload }) => {
    const [isHovered, setIsHovered] = useState(false);

    // Dimensioni responsive con clamp
    const qrSize = 'clamp(80px, 12vw, 150px)';
    const qrSizeNumber = window.innerWidth < 768 ? 80 : window.innerWidth < 1024 ? 120 : 150;

    return (
        <div
            style={{
                position: 'relative',
                width: qrSize,
                height: qrSize,
                cursor: 'pointer',
                borderRadius: "clamp(4px, 1vw, 8px)",
                overflow: "hidden"
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => onDownload(catalogue)}
        >
            <QRCodeCanvas
                id={`qr-code-${catalogue.id}`}
                value={getQrCodeUrl(catalogue)}
                size={qrSizeNumber}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                marginSize={4}
                level={"H"}
                style={{
                    borderRadius: "clamp(4px, 1vw, 8px)",
                    width: '100%',
                    height: '100%'
                }}
            />

            {/* Background overlay con opacità */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: primaryShades.primary300,
                    borderRadius: 'clamp(4px, 1vw, 8px)',
                    opacity: isHovered ? 0.90 : 0,
                    transition: 'opacity 0.3s ease-in-out',
                    pointerEvents: isHovered ? 'auto' : 'none'
                }}
            />

            {/* Icona di download (sempre a opacità piena) */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: isHovered ? 1 : 0,
                    transition: 'opacity 0.3s ease-in-out',
                    pointerEvents: 'none' // L'intero contenitore è già cliccabile
                }}
            >
                <FileDownloadIcon
                    style={{
                        color: 'white',
                        fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                        transform: isHovered ? 'scale(1)' : 'scale(0.8)',
                        transition: 'transform 0.3s ease-in-out'
                    }}
                />
            </div>
        </div>
    );
};

export default QRCodeWithHover;
